module.exports = __webpack_public_path__ + "img/40korting1.ead0da1a.png";